import { render, staticRenderFns } from "./mentorList.vue?vue&type=template&id=b46c073e&scoped=true&"
import script from "./mentorList.vue?vue&type=script&lang=js&"
export * from "./mentorList.vue?vue&type=script&lang=js&"
import style0 from "./mentorList.vue?vue&type=style&index=0&id=b46c073e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b46c073e",
  null
  
)

export default component.exports